import { useCallback } from "react"

import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../localization/useDateTime"

const FILE_SUFFIX_FORMAT = "yyyy-MM-dd-HHmm"

export type ExportStamp = Readonly<{
    columnTitle: string
    value: string
    fileSuffix: string
}>

export function useExportStamp() {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()

    return useCallback((): ExportStamp => {
        const exportedAt = dateTimeFactory.now()
        const columnTitle = l10n.getString("production-export-exported-label")

        return {
            columnTitle,
            value: dateTimeFactory.formatDateTime(exportedAt),
            fileSuffix: `${columnTitle}-${dateTimeFactory.formatCustom(exportedAt, FILE_SUFFIX_FORMAT)}`,
        }
    }, [dateTimeFactory, l10n])
}
